import React from 'react';
import styled from '@emotion/styled';
import { isEmpty } from 'lodash';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var ParagraphStyled = styled('p')(function (_ref) {
  var theme = _ref.theme,
      level = _ref.level;
  var paragraph = !isEmpty(theme) && theme.paragraphs["paragraph".concat(level)] || {};
  return _objectSpread({
    margin: 0,
    padding: 0
  }, paragraph);
});

var paragraphFactory = function paragraphFactory(level) {
  if (!level) {
    console.error('paragraphFactory: param level is undefined or invalid');
    return function () {
      return React.createElement("div", null);
    };
  }

  return function (props) {
    return React.createElement(ParagraphStyled, _extends({
      level: level
    }, props));
  };
};

var Paragraph1 = paragraphFactory(1);
var Paragraph2 = paragraphFactory(2);
var Paragraph3 = paragraphFactory(3);
var Paragraph4 = paragraphFactory(4);
var Paragraph5 = paragraphFactory(5);
var Paragraph6 = paragraphFactory(6);

export { Paragraph1, Paragraph2, Paragraph3, Paragraph4, Paragraph5, Paragraph6 };
